export function getApplication() {
  let appname = window.location.pathname.split('/')[1] // window.location.pathname.replace(/\//g, '')
  if (!appname || window.location.pathname.indexOf('/oauth/callback') == 0 || window.location.pathname.indexOf('/oauth/ybcallback') == 0 || window.location.pathname.indexOf('/cas/callback') == 0) {
    appname = 'admin'
  }
  return appname
}